import { useMemo } from 'react';

import { type Board } from '@air/api/types';

import { useGetPrivateBoardMenuOptionsCallback } from '~/components/PrivateGallery/useGetPrivateBoardMenuOptionsCallback';
import { type GetItemMenuOptions } from '~/constants/MenuOptions';
import { usePrivateBoardMetadataMenuOptions } from '~/hooks/usePrivateBoardMetadataMenuOptions';

export const usePrivateBoardMoreMenuOptions = (board: Board): GetItemMenuOptions => {
  const { getBoardMenuOptionsCallback } = useGetPrivateBoardMenuOptionsCallback();
  const metadataMenuOptions = usePrivateBoardMetadataMenuOptions(board);

  const getBaseOptions = useMemo(
    () => getBoardMenuOptionsCallback({ item: board }),
    [board, getBoardMenuOptionsCallback],
  );

  return useMemo(
    () =>
      ({ trackLocation }) => [...getBaseOptions({ trackLocation }), ...metadataMenuOptions],
    [getBaseOptions, metadataMenuOptions],
  );
};
